module.exports = __webpack_public_path__ + "img/yh_youji.d210246e.png";